import React from 'react'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down/index.js'

export default function WorkoutArrowDownIcon ({ isAboutVisible }) {
  return (
    <ArrowDownIcon
      style={{
        transform: isAboutVisible
          ? 'rotate(180deg)'
          : 'rotate(0deg)',
        transition: '1s'
      }}
    />
  )
}
